module.exports = __webpack_public_path__ + "static/product_icon-f5175cead570173ad6908e7f8b5fb82b.png";